export const CODE_LENGTH = 6;
